import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { InnerBlocks } from '@wordpress/block-editor';
export default function CommentTemplateSave() {
  return createElement(InnerBlocks.Content, null);
}
//# sourceMappingURL=save.js.map